
import { useState } from 'react';
import { reviews } from '../../../mocks/reviews';

function Avatar({ name, src }: { name: string; src: string }) {
  const [failed, setFailed] = useState(false);

  const initials = name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

  const colors = [
    'bg-teal-500', 'bg-amber-500', 'bg-rose-500',
    'bg-indigo-500', 'bg-emerald-500', 'bg-orange-500',
  ];
  const color = colors[name.charCodeAt(0) % colors.length];

  if (failed) {
    return (
      <div className={`w-14 h-14 rounded-full flex items-center justify-center ${color} text-white font-bold text-lg mr-4 shrink-0`}>
        {initials}
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={name}
      className="w-14 h-14 rounded-full object-cover mr-4 shrink-0"
      onError={() => setFailed(true)}
    />
  );
}

export default function Reviews() {
  return (
    <section id="reviews" className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-serif font-bold text-gray-900 mb-4">
            Client Reviews
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Hear what our clients have to say about their experience working with Exquisite Spaces
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reviews.map((review, index) => (
            <div key={index} className="bg-white border border-gray-200 rounded-3xl p-8 hover:shadow-xl transition-shadow">
              <div className="flex items-center mb-4">
                {[...Array(review.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-lg"></i>
                ))}
              </div>
              <p className="text-gray-700 leading-relaxed mb-6 italic">
                "{review.comment}"
              </p>
              <div className="flex items-center">
                <Avatar name={review.name} src={review.avatar} />
                <div>
                  <p className="font-bold text-gray-900">{review.name}</p>
                  <p className="text-sm text-gray-600">{review.location}</p>
                  <p className="text-xs text-gray-500 mt-1">{review.date}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button className="px-8 py-4 bg-teal-600 text-white rounded-full font-medium hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer">
            Read All Reviews
          </button>
        </div>
      </div>
    </section>
  );
}
